export { default, initialize } from '@sentry/ember/instance-initializers/sentry-performance';
